import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import { companyId, userId } from "../../../../utils/companyId";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import InputField from "../../../../Components/Masters/InputField";
import EditDialog from "../../../../Components/Common/EditDialog";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import { get, post, put } from "../../../../utils/api";
import EllipsisInputField from "../../../../Components/Common/EllipsisInputField";
import { useUser } from "../../../../context/AuthContext";
import Multiline from "../../../../Components/Masters/Multiline";
import formatTitleWithOptional from "../../OptionalFeild";

function AddData({
  inputData,
  fetchData,
  id,
  title,
  element,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
  handleClose,
}) {
  const { user } = useUser();
  const [errors, setErrors] = useState({});

  const initialState = {
    consumptionPeriod: {
      month: element?.consumptionPeriod?.month || "",
      year: element?.consumptionPeriod?.year || "",
    },
    product: element?.product?._id || "",
    quantityProduced: {
      value: element?.quantityProduced?.value || "",
      unit: element?.quantityProduced?.unit || "",
    },
    editRemarkReason: element?.editRemarkReason || "",
  };

  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);
  const [editDialog, setEditDialog] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});

  useEffect(() => {
    console.log(initialState);
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(element?.documents || []);
  }, [element, id]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    if (name === "product") {
      const res = await get(`/master/product/${value}`);
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        quantityProduced: {
          ...prevState.quantityProduced,
          unit: res?.data?.data?.unit,
        },
      }));
    }
    if (name.startsWith("quantity")) {
      const [field, key] = name.split(".");

      setFormData((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: value,
        },
      }));

      setErrors((prevState) => ({
        ...prevState,
        [field]: {
          ...prevState[field],
          [key]: "",
        },
      }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));

      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      console.log(input.fieldName, value);

      if (input.fieldName === "quantityProduced") {
        const cvValue = formData[input.fieldName]?.value || ""; // Ensure it's a string
        const cvUnit = formData[input.fieldName]?.unit || ""; // Ensure it's a string

        if (!validateNumber(cvValue)) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            value: "Numeric Value is required.",
          };
        }

        if (!cvUnit.trim()) {
          newErrors[input.fieldName] = {
            ...newErrors[input.fieldName],
            unit: "Unit is required.",
          };
        }
        return; // Ensure to return after handling errors for calorificValue
      }
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;

      if (input.fieldName === "consumptionPeriod") {
        if (!validateNumber(month)) newErrors["month"] = "Month is required";

        if (!validateNumber(year)) newErrors["year"] = "Year is required";

        return;
      }
      // Handle required fields
      if (
        ((input.type === "text" || input.type === "select") && input?.fieldName!=="editRemarkReason") &&
        !value?.trim()
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
    });

    setErrors(newErrors);
    console.log(newErrors, "new1");
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }

    const url = id ? `${updateUrl}?Id=${id}` : addUrl;
    const dataToSend = { ...formData, documents: uploadedFiles };

    try {
      if (user?.endUser && id) {
        dataToSend.requestStatus = "edit";
        dataToSend.requestMode = true;
        dataToSend.approvalStatus = "Pending";
      }
      const response = id
        ? await put(url, dataToSend)
        : await post(url, dataToSend);

      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });

      fetchData();

      setFormData(initialState);
      setUploadedFiles([]);
      handleClose();
    } catch (error) {
      console.error("Save Error:", error);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessages = error.response.data.errors
          .map((err) => err.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else {
        alert(error.message || "An error occurred while saving the data.");
      }
    }
  };

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState); // Reset form data to initial state
    setUploadedFiles(element?.documents || []);
    handleClose();
  };

  const handleExit = () => {
    const isFormDataUnchanged = Object.keys(formData).every(
      (key) => formData[key] === formData2[key]
    );
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true); // Show the EditDialog if there are changes
    }
  };

  const renderInputField = (el) => {
    if (
      el.fieldName === "quantityOfWasteManaged" &&
      formData?.wasteManagementMethod === "Landfilling"
    )
      return;
    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 1 }}>
          <MonthYearPicker
            {...{
              name: el.fieldName,
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
              title: el.title,
              // defaultMonth: formData?.consumptionPeriod?.month || "",
              // defaultYear: formData?.consumptionPeriod?.year || "",
            }}
          />
        </Box>
      );
    }
    if (el.fieldName === "quantityProduced") {
      return (
        <Box>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: "bold", mt: 1, mb: -1 }}
          >
            {el.title}
          </Typography>
          <Box display="flex" gap={1} sx={{ width: "100%" }}>
            <Box sx={{ width: "50%" }}>
              <InputField
                // title={el.title}
                handleChange={handleChange}
                placeholder={el.placeholder}
                value={formData[el.fieldName]?.value || ""}
                errors={errors[el.fieldName]?.value} // Access error for value
                fieldName={`${el.fieldName}.value`}
              />
            </Box>
            <Box sx={{ width: "50%" }}>
              <EllipsisInputField
                marginTop="0px"
                fieldName={`${el.fieldName}.unit`}
                value={formData[el.fieldName]?.unit}
                // handleChange={handleChange}
                // options={el.options}
                disabled={true}
                errors={errors[el.fieldName]?.unit} // Access error for unit
                // field={`${el.field}.unit`}
                placeholder="Unit"
              />
            </Box>
          </Box>
        </Box>
      );
    }

    if (el.type === "select" || el.options) {
      return (
        <SelectField
          title={el.title}
          name={el.fieldName}
          value={formData[el.fieldName]}
          url={el.url}
          field={el.field}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
        />
      );
    }
    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }

    if (el.type === "file") {
      return (
        <FileField
          title={el.title}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    return (
      <InputField
        title={el.title}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.nested ? formData[el.fieldName]?.value : formData[el.fieldName]
        }
        errors={errors[el.fieldName] || ""}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""}
      />
    );
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{ width: "26.5rem", maxWidth: "100%", height: "100%" }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleExit} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title}` : `Add ${title}`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              position: "fixed",
              bottom: "2rem",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleExit}
    >
      {list()}
    </Drawer>
  );
}

export default AddData;
